import { render, staticRenderFns } from "./AnotherExam.vue?vue&type=template&id=7be9dc4b&scoped=true&"
import script from "./AnotherExam.vue?vue&type=script&lang=js&"
export * from "./AnotherExam.vue?vue&type=script&lang=js&"
import style0 from "./AnotherExam.vue?vue&type=style&index=0&id=7be9dc4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be9dc4b",
  null
  
)

export default component.exports